import { useAppDispatch } from "../../../store/hooks/StoreHooks";
import { fetchAllProjects, fetchCountryByState, fetchCountyByState, fetchStatesByCountry, resetProjectDetails, setCaseName, setCompanyName, setCountryList, setCountrySelected, setCountyList, setCountyOther, setCountySelected, setCustomerContact, setFormation, setProjectName, setProjectTabDetails, setRep, setStateList, setStateSelected, setWellAPINo, setWellName } from "../../../store/calculation/calculation-input/ProjectTabSlice";
import { Tab4Input } from "../../../store/model/calculations/projectTab";

const useProjectTabFacade = () => {
    const dispatch = useAppDispatch();

    const updateCountryList = (payload: any) => {
        return dispatch(setCountryList(payload));
    };

    const updateStateList = (payload: any) => {
        return dispatch(setStateList(payload));
    };

    const updateCountyList = (payload: any) => {
        return dispatch(setCountyList(payload));
    };

    const getStatesByCountry = async () => {
        return await dispatch(fetchStatesByCountry());
    };

    const getCountyByState = async (stateID: string) => {
        return await dispatch(fetchCountyByState(stateID));
    };

    const getCountryByState = async (stateID: string) => {

        return await dispatch(fetchCountryByState(stateID));
    };

    const updatProjectTabDetails = (payload: Tab4Input) => {
        return dispatch(setProjectTabDetails(payload));
    };

    const updateProjectName = (payload: string) => {
        return dispatch(setProjectName(payload));
    };

    const updateCaseName = (payload: string) => {
        return dispatch(setCaseName(payload));
    };

    const updateCompanyName = (payload: string | number) => {
        return dispatch(setCompanyName(payload));
    };

    const updateCustomerContact = (payload: string) => {
        return dispatch(setCustomerContact(payload));
    };

    const updateWellName = (payload: string | number) => {
        return dispatch(setWellName(payload));
    };

    const updateWellAPI = (payload: string) => {
        return dispatch(setWellAPINo(payload));
    };

    const updateCountrySelected = (payload: string) => {
        return dispatch(setCountrySelected(payload));
    };

    const updateStateSelected = (payload: string) => {
        return dispatch(setStateSelected(payload));
    };

    const updateCountySelected = (payload: string) => {
        return dispatch(setCountySelected(payload));
    };

    const updateCountyOther = (payload: string) => {
        return dispatch(setCountyOther(payload));
    };

    const updateFormation = (payload: string) => {
        return dispatch(setFormation(payload));
    };

    const updateREP = (payload: string) => {
        return dispatch(setRep(payload));
    };

    const updateResetProjectDetails = () => {
        return dispatch(resetProjectDetails());
    };

    return {
        updateCountryList,
        updateStateList,
        updateCountyList,
        getStatesByCountry,
        getCountyByState,
        updatProjectTabDetails,
        updateProjectName,
        updateCaseName,
        updateCompanyName,
        updateCustomerContact,
        updateWellName,
        updateWellAPI,
        updateCountrySelected,
        updateStateSelected,
        updateCountySelected,
        updateCountyOther,
        updateFormation,
        updateREP,
        updateResetProjectDetails,
        getCountryByState,
    };
};

export default useProjectTabFacade;